import React, { useEffect, useState } from 'react';
import './appIntro.css'

function C2wAppIntro() {

  const blueCircle = (
    <svg className='blueCircle' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14.5564" cy="14.5564" r="14.5564" fill="#0A91F2"/>
      <circle cx="14.5564" cy="14.5564" r="14.5564" fill="url(#paint0_linear_7544_19746)"/>
      <defs>
      <linearGradient id="paint0_linear_7544_19746" x1="20.7833" y1="4.36692" x2="0.0704888" y2="11.2083" gradientUnits="userSpaceOnUse">
      <stop stop-color="#8FBFEB"/>
      <stop offset="1" stop-color="#207CD1"/>
      </linearGradient>
      </defs>
    </svg>
  )

  const yellowCircle = (
    <svg className='yellowCircle'  width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10.7032" cy="10.7032" r="10.7032" fill="#B09FEA"/>
      <circle cx="10.7032" cy="10.7032" r="10.7032" fill="url(#paint0_linear_7544_19747)"/>
      <defs>
      <linearGradient id="paint0_linear_7544_19747" x1="6.04703" y1="19.6672" x2="17.8214" y2="2.7706" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFB320"/>
      <stop offset="1" stop-color="#FFF733"/>
      </linearGradient>
      </defs>
    </svg>
  )

  const pinkStar = (
    <svg  className= 'pinkStar' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5564 0L18.1589 10.9539L29.1128 14.5564L18.1589 18.1589L14.5564 29.1128L10.9539 18.1589L0 14.5564L10.9539 10.9539L14.5564 0Z" fill="#F34D4D"/>
</svg>

  )


  /**
   * @state windowWidth
   * @hook useEffect - Window Resize Listener
   * @author Vishal Lohbande
   *
   * Description:
   * - Initializes `windowWidth` state with the current window width.
   * - Adds a resize event listener on the window to update `windowWidth` whenever the window size changes.
   *
   * Behavior:
   * - The `handleResize` function updates the `windowWidth` state with the new window width.
   * - Cleanup function removes the event listener on component unmount to prevent memory leaks.
   *
   * Usage:
   * - Useful for responsive design decisions based on the current viewport width.
   */
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

  return (
    <div className='C2wAppIntro_ctn'>
        <div className='C2wAppIntro_content_holder'>
            { <img  className='C2wAppIntro_content_bg_img' src={`/assets/images/appIntro/${windowWidth > 620 ? `appIntroBg.png` : `appIntroMobileView_bg.png` }`} alt='appIntroBg' />}
            {/* {<img  className='C2wAppIntro_content_bg_img' src='/assets/images/appIntro/appIntroMobileView_bg.png' alt='appIntroMobileView_bg' />} */}
            <div className='C2wAppIntro_content_Info_ctn'>
                <h3>{'Best learning companion'}</h3>
                <div className='C2wAppIntro_content_Info'>
                  <p>{'Highly interactive cross-platform app developed by Incubators Systems.'}</p>
                  <p><span>{'15,000+ students'} </span>{'benefited from this app.'}</p>
                </div>
                <div className='C2wGoogleplayicon_holder'>
                  <a
                  href="https://play.google.com/store/apps/details?id=com.developer.core2web2&pcampaignid=web_share"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className='googleplayicon' src='/assets/images/aboutus/googleplayicon.png' alt='googlePlay-icon' />
                  </a>
                  <img className='playStoreYellowGradient' src='/assets/images/appIntro/yellowGradient.png' alt='yellowGradient' />
                </div>
                {/*Absolute Icons Assets */}
                {blueCircle}
                {yellowCircle}
                {pinkStar}
            </div>
            <div className='C2wAppIntro_content_img_holder'> 
              <div className='AppIntroMobileImg_holder'>
                <img className='appintroMobile1Home' src='/assets/images/appIntro/appintroMobile1.png' alt='appintroMobile1' />
                <img className='appintroMobile2' src='/assets/images/appIntro/appintroMobile2.png' alt='appintroMobile2' />
                <img className='appintroTriangle' src='/assets/images/appIntro/appintroTriangle.png' alt='appintroTriangle' />
                <img className='appIntroMobileShadow' src='/assets/images/appIntro/appIntroMobileShadow.png' alt='appIntroMobileShadow' />
                <img className='gradient blueGradient' src='/assets/images/appIntro/blueGradient.png'  alt='blueGradient'/>
                <img className='gradient yellowGradient' src='/assets/images/appIntro/yellowGradient.png'  alt='yellowGradient'/>
              </div>
            </div>
        </div>
    </div>
  )
}

export default C2wAppIntro
